import { Body } from "detect-collisions";

export class CollisionShape {
    body: Body
}